import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.455 2c1.807 0 3.272 1.508 3.272 3.368 0 .614-.16 1.19-.438 1.686L19 7.053v1.684h-1.636v8.42a.83.83 0 0 1-.819.843H3.456a.83.83 0 0 1-.819-.842V8.737H1V7.053h3.711a3.4 3.4 0 0 1-.438-1.685C4.273 3.508 5.738 2 7.545 2c.978 0 1.856.441 2.456 1.141A3.22 3.22 0 0 1 12.455 2M9.182 8.737h-4.91v7.579h4.91zm6.545 0h-4.909v7.579h4.91zM7.545 3.684c-.903 0-1.636.754-1.636 1.684 0 .888.668 1.616 1.514 1.68l.122.005h1.637V5.368c0-.843-.603-1.542-1.389-1.665l-.125-.014zm4.91 0c-.863 0-1.57.687-1.632 1.559l-.005.125v1.685h1.637c.862 0 1.569-.687 1.631-1.559l.005-.126c0-.93-.733-1.684-1.636-1.684"
    }, null, -1)
  ])))
}
export default { render: render }